import { useEffect, useState } from 'react';

function useMediaQuery(query: string, initialMatch = false): boolean {
  const [matches, setMatches] = useState(initialMatch);
  const [, setReady] = useState(false); // ready to be use later?

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const mediaQueryList = window.matchMedia(query);
    const handleMediaChange = event => setMatches(event.matches);

    // Set initial state
    setMatches(mediaQueryList.matches);
    setReady(true);

    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener('change', handleMediaChange);
    } else if (mediaQueryList.addListener) {
      mediaQueryList.addListener(handleMediaChange);
    }

    return () => {
      if (mediaQueryList.removeEventListener) {
        mediaQueryList.removeEventListener('change', handleMediaChange);
      } else if (mediaQueryList.removeListener) {
        mediaQueryList.removeListener(handleMediaChange);
      }
    };
  }, [query]);

  return matches;
}

export default useMediaQuery;
